import { render, staticRenderFns } from "./ColumnProxy.vue?vue&type=template&id=049491ec&scoped=true"
import script from "./ColumnProxy.vue?vue&type=script&lang=ts"
export * from "./ColumnProxy.vue?vue&type=script&lang=ts"
import style0 from "./ColumnProxy.vue?vue&type=style&index=0&id=049491ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049491ec",
  null
  
)

export default component.exports